<template>
  <div class="admin-table-wrapper">
    <b-row v-if="showTopButtons" class="top-buttons">
      <b-col>
        <slot name="top-buttons" />
        <b-button v-if="!config.hideActionNewButton &&
          config.useNewModal &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_new')
          " class="float-right mb-35" variant="outline-primary" size="lg" @click="openFormModal()">
          Nouveau
          <i class="far fa-plus ml-10"></i>
        </b-button>
        <b-button v-else-if="!config.hideActionNewButton &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_new')
          " class="float-right mb-35" variant="outline-primary" size="lg" :to="{ name: config.newRouteName }">
          Nouveau
          <i class="far fa-plus ml-10"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="tab_filter" class="tabs d-flex flex-row" ref="tabs">
          <div v-for="option in options[tab_filter.name + '_options']" :key="option.value" :ref="'tab_' + option.value"
            @click="setTab($event, option.value)" :class="{
          tab: true,
          active: option.value == tab_filter_default_value,
        }">
            {{ option.text }}
          </div>
          <div :class="{ tab: true, active: !tab_filter_default_value }" @click="setTab($event, null)">
            Tout
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content">
            <div class="filters">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 search-bar">
                  <b-form-group inline class="mb-0">
                    <b-input-group>
                      <label class="mb-0 align-self-center">
                        <i class="far fa-search fa-lg"></i>
                      </label>
                      <b-form-input v-model="filter" placeholder="Rechercher" />
                      <b-input-group-append v-if="filter &&
          (!this.config.showExtendedFilters ||
            this.config.showExtendedFilters !== true)
          ">
                        <b-button :disabled="!filter" @click="filter = ''">
                          <i class="far fa-times"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="ml-2 filters-toggle" v-if="extended_filters.length &&
          (!this.config.showExtendedFilters || this.config.showExtendedFilters !== true)
          " @click.prevent="toggleExtendedFilters()">
                  <a href v-if="extended_filters_is_open">
                    Moins d'options
                    <i class="fa fa-chevron-up ml-1"></i>
                  </a>
                  <a href v-else>
                    Plus d'options
                    <i class="fa fa-chevron-down ml-1"></i>
                  </a>
                </div>
                <div class="ml-2 filters-toggle" v-else @click.prevent="resetFilters()">
                  <a href>
                    Reset
                    <i class="fa fa-undo ml-1"></i>
                  </a>
                </div>
              </div>
              <b-form v-if="extended_filters.length && extended_filters_is_open">
                <b-row>
                  <b-col v-for="extended_filter in extended_filters" :key="extended_filter.name" class="filter-col">
                    <b-form-group :label="extended_filter.label + ' :'" :label-for="'filter-' + extended_filter.name">
                      <b-form-select :id="'filter-' + extended_filter.name" v-if="extended_filter.type == 'select'"
                        v-model="extended_filters_model[extended_filter.name]"
                        :options="options[extended_filter.name + '_options']">
                        <!-- This slot appears above the options from 'options' prop -->
                        <template slot="first">
                          <option :value="null">-- Tout --</option>
                        </template>
                      </b-form-select>
                      <Chosen :id="'filter-' + extended_filter.name" v-if="extended_filter.type == 'chosen'"
                        v-model="extended_filters_model[extended_filter.name]"
                        :options="options[extended_filter.name + '_options']" allowAll="true" label="text"
                        trackBy="value" searchContains="true"></Chosen>
                      <div v-if="extended_filter.type == 'date'" class="d-flex">
                        <datepicker :id="'filter-' + extended_filter.name" input-class="form-control"
                          v-model="extended_filters_model[extended_filter.name]['start']" :format="'dd/MM/yyyy'"
                          :monday-first="true" :language="fr" :clear-button="true"
                          clear-button-icon="fa fa-times fa-lg">
                        </datepicker>
                        <div class="align-self-center ml-1 mr-1">Au</div>
                        <datepicker :id="'filter-' + extended_filter.name + '-2'" input-class="form-control"
                          v-model="extended_filters_model[extended_filter.name]['end']" :format="'dd/MM/yyyy'"
                          :monday-first="true" :language="fr" :clear-button="true"
                          clear-button-icon="fa fa-times fa-lg">
                        </datepicker>
                      </div>
                      <b-form-input v-if="extended_filter.type == 'text'" class="flex-fill"
                        :id="'filter-' + extended_filter.name" type="text"
                        v-model="extended_filters_model[extended_filter.name]" />
                      <!-- Filtre autocomplete : le composant est nommé par la config (`filterComponent`) et
                           doit être enregistré globalement. Sert aux référentiels trop volumineux pour un
                           <select> — soixante-dix familles d'équipement, par exemple, où l'on cherche par
                           le nom plutôt qu'en déroulant. Les options viennent de la vue hôte, comme pour
                           les autres types de filtre. -->
                      <component v-if="extended_filter.type == 'autocomplete'"
                        :is="extended_filter.filterComponent" :id="'filter-' + extended_filter.name"
                        :placeholder="extended_filter.filterPlaceholder"
                        :options="options[extended_filter.name + '_options']"
                        v-model="extended_filters_model[extended_filter.name]" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </div>

            <b-row class="mt-4">
              <b-col>
                <div class="d-flex align-items-center">
                  <b-form-checkbox v-if="!config.hideActionCsvButton && items && items.length" class="select-all"
                    v-model="allSelected" :value="true" :unchecked-value="false" @change="toggleSelectAll">
                    Tout sélectionner
                    <span v-if="selectedRowsCount" class="text-lowercase">({{ selectedRowsCount | thousands }} lignes
                      sélectionnées)</span>
                  </b-form-checkbox>
                  <b-form inline class="ml-auto">
                    <!-- QR-005 : point d'extension pour les actions groupées propres à une
                         liste (ex. impression d'étiquettes). Purement additif : les listes
                         qui ne fournissent pas ce slot sont inchangées. -->
                    <slot name="bulk-actions" :selected-rows="selectedRows"></slot>
                    <download-csv v-if="!config.hideActionCsvButton && selectedRowsCount"
                      class="btn btn-outline-primary" :data="exportCsvRows" :fields="exportCsvFields"
                      :labels="exportCsvLabels" :name="exportCsvFilename" delimiter=";">Exporter en CSV</download-csv>
                    <b-form-group class="mb-0 ml-10" v-if="!config.sortable">
                      <b-input-group>
                        <b-form-select v-model="perPage" :options="perPageOptions" />
                      </b-input-group>
                    </b-form-group>
                  </b-form>
                </div>
              </b-col>
            </b-row>

            <div class="table-wrapper mt-2">
              <b-table ref="table" hover show-empty :fields="fields" :items="filtred_items"
                :sort-by="config.sortBy || null" :sort-desc="config.sortDesc || false" :filter="filter"
                :filter-function="filterFunction" @filtered="onFiltered" :current-page="currentPage"
                :per-page="parseInt(perPage)" :selectable="!config.hideActionCsvButton" :select-mode="'multi'"
                selectedVariant="info" @row-selected="rowSelected" :busy="isBusy">
                <div slot="table-busy" class="text-center my-2">
                  <div v-if="isBusy" class="loader"></div>
                  Les données sont en cours de chargement...
                </div>
                <template slot="empty" slot-scope="scope">
                  <div v-if="config.newRouteName" class="text-center mt-2">
                    Cette liste est vide pour le moment, soyez le premier à créer un enregistrement
                    <!-- <br>
                    <b-button
                      v-if="config.useNewModal && config.authFeature && $store.getters['auth/isAuthorized'](config.authFeature+'_new')"
                      class="mt-2 mb-2"
                      variant="outline-primary"
                      size="lg"
                      @click="openFormModal()"
                    >
                      Nouveau
                      <i class="far fa-plus ml-10"></i>
                    </b-button>
                    <b-button
                      v-else-if="config.authFeature && $store.getters['auth/isAuthorized'](config.authFeature+'_new')"
                      class="mt-2 mb-2"
                      variant="outline-primary"
                      size="lg"
                      :to="{name:config.newRouteName}"
                    >Nouveau</b-button>-->
                  </div>
                  <div v-else class="text-center mt-2">Cette liste est vide pour le moment</div>
                </template>
                <template slot="emptyfiltered" slot-scope="scope">
                  <div class="text-center mt-2">Aucun résultat ne correspond à la recherche</div>
                </template>

                <template slot="select" slot-scope="data">
                  <b-form-checkbox :name="'select-' + data.item.id" :checked="data.rowSelected"
                    @change="toggleSelectRow(data.index + 1)"></b-form-checkbox>
                </template>
                <template slot="sort" slot-scope="data">
                  <a @click="orderUp(data.item.id)"><i class="fas fa-sort-up"></i></a> <br />
                  <a @click="orderDown(data.item.id)"><i class="fas fa-sort-down"></i></a></template>
                <template v-for="field in config.fields.filter((field) => field.inList == true)" :slot="field.name"
                  slot-scope="data">
                  <b-badge v-if="field.type == 'yesno' && data.value == true" :key="field.name" variant="success"
                    class="circle float-left">
                    <i class="fa fa-check"></i>
                  </b-badge>
                  <b-badge v-else-if="field.type == 'yesno' && data.value == false" :key="field.name" variant="danger"
                    class="circle float-left">
                    <i class="fa fa-times"></i>
                  </b-badge>
                  <template v-else-if="field.type == 'date' && data.value">{{
          data.value | moment("DD-MM-YYYY")
        }}</template>
                  <slot v-else :name="field.name" :data="data">{{ data.value }}</slot>
                </template>

                <template :slot="config.titleField" slot-scope="data">
                  <router-link v-if="config.detailRouteName &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_show')
          " :to="{
          name: config.detailRouteName,
          params: { id: data.item.id },
        }">
                    <template v-if="config.fields.find((field) => field.name == config.titleField).type ==
          'date'
          ">{{ data.value | moment("DD-MM-YYYY") }}</template>
                    <template v-else>{{ data.value }}</template>
                  </router-link>
                  <template v-else>{{ data.value }}</template>
                </template>
                <template slot="actions" slot-scope="data">
                  <b-button-group size="sm" class="actions">
                    <slot name="actions" :data="data"></slot>
                    <b-button v-b-tooltip.hover title="Editer" variant="outline-secondary" v-if="config.useEditModal &&
          !config.hideActionEditButton &&
          data.item.id &&
          ((config.editCondition && config.editCondition(data.item)) ||
            !config.editCondition) &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_edit')
          " @click="openFormModal(data.item.id)">
                      <i class="far fa-pencil"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Editer" variant="outline-secondary" v-if="!config.useEditModal &&
          !config.hideActionEditButton &&
          data.item.id &&
          ((config.editCondition && config.editCondition(data.item)) ||
            !config.editCondition) &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_edit')
          " :to="{
          name: config.editRouteName,
          params: { id: data.item.id },
        }">
                      <i class="far fa-pencil"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Exporter en PDF" variant="outline-secondary"
                      v-if="!config.hideActionPdfButton && data.item.id" @click.prevent="exportPdfSingle(data.item)">
                      <i class="far fa-file-alt"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Supprimer" variant="outline-secondary" v-if="!config.hideActionDeleteButton &&
          data.item.id &&
          ((config.deleteCondition && config.deleteCondition(data.item)) ||
            !config.deleteCondition) &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_delete')
          " @click.prevent="deleteItem(data.item.id)">
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>

            <div class="total float-right">
              {{ (parseInt(perPage) < parseInt(totalRows) ? perPage : totalRows) | thousands }} / <strong>{{ totalRows | thousands }}</strong>
                résultats
            </div>

            <b-pagination class="mb-0" align="center" size="sm" :total-rows="totalRows" :per-page="parseInt(perPage)"
              v-model="currentPage" />
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm v-if="config.useNewModal || config.useEditModal" :config="config" :id_to_edit="id_to_edit"
      @submit:create:success="submitCreateSuccess" @submit:update:success="submitUpdateSuccess"
      @submit:create:error="submitCreateError" @submit:update:error="submitUpdateError" />
  </div>
</template>

<script>
import AdminModalForm from "@/components/Global/AdminModalForm";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import Chosen from "@/components/Global/Chosen";

export default {
  name: "AdminTable",
  components: {
    AdminModalForm,
    Datepicker,
    Chosen,
  },
  props: ["config", "options", "source_items"],
  data() {
    return {
      filtred_items: [],
      totalRows: 0,
      fields: [],
      currentPage: 1,
      perPage: 20,
      perPageOptions: {
        10: "10 par page",
        20: "20 par page",
        50: "50 par page",
        100: "100 par page",
        999999999: "Tout afficher", // On ne met pas une valeur vide car cela aurait pour conséquence de ne pas appliquer d'attribut aria-rowindex sur les lignes. Et on en a besoin pour l'usage des checkbox
      },
      allSelected: false,
      selectedRowsCount: 0,
      // QR-005 : lignes sélectionnées, exposées au slot bulk-actions.
      selectedRows: [],
      exportCsvFields: [],
      exportCsvLabels: {},
      exportCsvRows: [],
      exportCsvFilename:
        this.config.csvExportFilenamePrefix + "-" + this.$moment().format("YYYY-MM-DD") + ".csv",
      isBusy: false,
      filter: null,
      extended_filters: [],
      extended_filters_model: {},
      extended_filters_is_open: this.config.showExtendedFilters || false,
      tab_filter: null,
      tab_filter_default_value: null,
      id_to_edit: null,
      en: en,
      fr: fr,
      updateOrderTimer: null,
    };
  },
  computed: {
    // On lie 'items' au données du store (sauf si des données sont passées du parent)
    items: function () {
      return typeof this.source_items !== "undefined"
        ? this.source_items || []
        : this.$store.getters[this.config.storeNamespace + "/getAll"];
    },
    // La rangée top-buttons remonte de 85px (voir style) pour coller le bouton
    // « Nouveau » au titre. Vide, elle recouvre le contenu situé au-dessus et en
    // bloque les clics : on ne la rend que si elle a un contenu (bouton ou slot).
    showTopButtons: function () {
      if (this.$slots["top-buttons"] || this.$scopedSlots["top-buttons"]) {
        return true;
      }
      return (
        !this.config.hideActionNewButton &&
        !!this.config.authFeature &&
        this.$store.getters["auth/isAuthorized"](this.config.authFeature + "_new")
      );
    },
  },
  watch: {
    // Remonte en haut de page au changement de page : la pagination est sous le tableau,
    // si bien qu'on y arrive en bas et qu'on y restait — la nouvelle page s'ouvrait sur
    // ses dernières lignes, l'en-tête et les filtres hors écran.
    currentPage: function () {
      window.scrollTo({ top: 0, left: 0 });
    },
    source_items: function (items) {
      if (items !== null || items.length) {
        this.isBusy = false;
      }
    },
    // Quand 'items' change, on met aussi à jour la liste des items filtrés
    // (utile dans le cas ou on reçoit les données depuis l'API avec un délais)
    items: function (items) {
      this.filtred_items = this.$root.formatDatas(
        items,
        this.config.fields.filter((field) => field.inList == true),
        true
      );
      this.extentedFiltersFunction(this.extended_filters_model);
    },
    // Quand la liste filtrée est mise à jour, on met à jour le nombre de lignes pour le fonctionnement de la pagination
    filtred_items: function (filtred_items) {
      this.totalRows = filtred_items.length;
    },
    // Quand les filtres étendus changent
    extended_filters_model: {
      handler: function (newFiltersValues) {
        this.extentedFiltersFunction(newFiltersValues);
      },
      deep: true,
    },
  },
  mounted() {
    // On récupère la liste des filtres étendus (en plus du champ de recherche)
    this.extended_filters = this.config.fields.filter((field) => field.extendedFilter == true);
    const extended_filters_model = {};
    this.extended_filters.forEach((filter) => {
      if (filter.type == "date") {
        extended_filters_model[filter.name] = {
          start: null,
          end: null,
        };
      } else {
        extended_filters_model[filter.name] = null;
      }
    });
    this.extended_filters_model = extended_filters_model;

    // On récupère le filtre par onglet, et on l'ajoute au model des filtres etendus
    this.tab_filter = this.config.fields.find((field) => field.tabFilter == true) || null;
    if (this.tab_filter && this.tab_filter) {
      extended_filters_model[this.tab_filter.name] = null;
      this.extended_filters_model = extended_filters_model;
    }

    // Valeur par défaut du filtre par onglet (si défini)
    if (this.tab_filter) {
      this.tab_filter_default_value = this.tab_filter.tabFilterDefaultValue || null;
      this.extended_filters_model[this.tab_filter.name] = this.tab_filter_default_value;
    }

    // On demande au store de se mettre à jour à partir de l'API
    if (typeof this.source_items === "undefined") {
      this.$store
        .dispatch(this.config.storeNamespace + "/getAll")
        .then(() => {

          // Filtrage par url
          if (this.$route.params.hasOwnProperty('defaultFilterField') && this.$route.params.hasOwnProperty('defaultFilterValue')) {

            let fields = this.$route.params.defaultFilterField.split(',')
            let values = this.$route.params.defaultFilterValue.split(',')

            for (let i = 0; i < fields.length; i++) {
              if (this.extended_filters_model.hasOwnProperty(fields[i])) {
                if (fields[i] == 'status') {
                  this.tab_filter_default_value = values[i] == 'null' ? null : values[i]
                }
                this.extended_filters_model[fields[i]] = values[i] == 'null' ? null : values[i];
              }
            }
          }

          this.isBusy = false;
        })
        .catch((error) => console.error(error));
    }

    // On copie directement la liste des items dans la liste des items filtrés
    this.filtred_items = this.$root.formatDatas(
      this.items,
      this.config.fields.filter((field) => field.inList == true),
      true
    );

    // Si il n'y a pas déjà des items dans le store, on affiche le loader le temps que le store se mette à jour
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }

    // Chargement des champs à afficher dans la liste depuis la config pour les passer au composant AdminTable
    this.fields = this.config.fields
      .filter((field) => field.inList == true)
      .map((field) => ({
        key: field.name,
        label: field.label,
        sortable: field.sortable || false,
      }));

    // Si l'export CSV est activé, on ajoute une colonne avec checkbox pour la sélection des lignes
    if (!this.config.hideActionCsvButton) {
      this.fields.unshift({ key: "select", label: "" });
    }

    // Si la réodronnation est activée, on ajoute une colonne avec fleches pour la changement d'ordre
    if (this.config.sortable) {
      this.fields.unshift({ key: "sort", label: "Réordonner" });
      this.perPage = 999999999;
    }

    if (
      (!this.config.hideActionEditButton &&
        this.config.authFeature &&
        this.$store.getters["auth/isAuthorized"](this.config.authFeature + "_edit")) ||
      !this.config.hideActionPdfButton ||
      (!this.config.hideActionDeleteButton &&
        this.config.authFeature &&
        this.$store.getters["auth/isAuthorized"](this.config.authFeature + "_delete")) ||
      this.$scopedSlots.actions
    ) {
      this.fields.push({ key: "actions", label: "Actions" });
    }

    // Chargement des champs à exporter en CSV depuis la config pour les passer au composant AdminTable
    this.exportCsvFields = this.config.fields
      .filter((field) => field.inCsvExport == true)
      .map((field) => field.name);
    this.config.fields
      .filter((field) => field.inCsvExport == true)
      .forEach((field) => {
        this.exportCsvLabels[field.name] = field.label;
      });

    // Quand la modale d'édition / création se ferme, on retire le paramètre de l'URL
    this.$root.$on("bv::modal::hidden", this.onModalHidden);

    // Réouverture de la modale d'édition si un id est présent dans l'URL (?edit=<id>)
    this.$nextTick(() => {
      const editId = this.$route.query.edit;
      if (editId && (this.config.useEditModal || this.config.useNewModal)) {
        this.openFormModal(parseInt(editId));
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("bv::modal::hidden", this.onModalHidden);
  },
  methods: {
    /**
     * Gère l'apparition ou le masquage des filtres étendus
     */
    toggleExtendedFilters() {
      this.extended_filters_is_open = !this.extended_filters_is_open;

      // Si on ferme les filtres, on reset ceux-ci
      if (!this.extended_filters_is_open) {
        this.resetFilters();
      }
    },
    /**
     * Remise à zéro de tous les filtres
     */
    resetFilters() {
      this.filter = "";

      this.extended_filters.forEach((filter) => {
        if (filter.type == "date") {
          this.extended_filters_model[filter.name] = {
            start: null,
            end: null,
          };
        } else {
          this.extended_filters_model[filter.name] = null;
        }
      });
    },
    /**
     * Toggle la sélection de tous les items
     */
    toggleSelectAll() {
      if (!this.allSelected) {
        this.selectAll();
      } else {
        this.unselectAll();
      }
    },
    /**
     * Sélection de toutes les lignes
     */
    selectAll() {
      var self = this;

      $(self.$refs.table.$el).find("tbody tr:not(.b-row-selected)").trigger("click");
    },
    /**
     * Désélection de toutes les lignes
     */
    unselectAll() {
      $(this.$refs.table.$el).find("tbody tr.b-row-selected").trigger("click");
    },
    /**
     * Toggle la sélection d'une ligne lorsque la checkbox est cochée ou décochée
     * @param {integer} index index de la ligne (commence à 1 pour la première ligne)
     */
    toggleSelectRow(index) {
      $(this.$refs.table.$el)
        .find("tbody tr[aria-rowindex='" + index + "']")
        .trigger("click");
    },
    /**
     * Supprime un item (via le store)
     * @param {integer} id  Id de l'item à supprimer
     */
    deleteItem(id) {
      if (confirm("Êtes-vous sur de vouloir supprimer cet élément ?")) {
        this.$store
          .dispatch(this.config.storeNamespace + "/deleteItem", id)
          .then((response) => {
            this.$emit("delete:success", response);
          })
          .catch((error) => {
            this.$emit("delete:error", error);
          });
      }
    },
    /**
     * Callback appelé lorsque le champ de recherche est utilisé
     * Met à jour le nombre d'items trouvés et retourne à la page 1
     */
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     * Fonction de filtrage utilisée par le champ de recherche.
     * Cette fonction est appliquée sur chaque item la liste
     * @param   {object}    row     Objet de la ligne à vérifier
     * @param   {string}    filter  Mots clés saisis dans le champ de recherche
     * @returns {boolean}           True si la ligne testée correspond à la recheche, sinon false
     */
    filterFunction(row, filter) {
      const fieldToFilter = this.config.fields
        .filter((field) => field.filterIn == true)
        .map((field) => field.name);
      const regex = new RegExp(filter.toLowerCase().replace(/\s/g, ".*"), "gi");
      for (let index = 0; index < fieldToFilter.length; index++) {
        const field_name = fieldToFilter[index];
        const row_value = resolve(row, field_name);

        if (row_value) {
          if (row_value.toString().toLowerCase().match(regex) !== null) {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    /**
     * Fonction de filtrage via les filtres étendus (inclus les onglets)
     * @param   {object}    newFiltersValues    Objet model des filtres étendus
     */
    extentedFiltersFunction(newFiltersValues) {
      // On concatene les filtres étendués et les onglets
      // comme ça on a une seule méthode de filtrage pour tous
      const all_filters = this.tab_filter
        ? [...this.extended_filters, this.tab_filter]
        : [...this.extended_filters];

      // On filtre à partir de la liste de base des items
      this.filtred_items = this.$root.formatDatas(
        this.items.filter((item) => {
          if (all_filters.length) {
            // Pour chaque filtre, on va vérifier si la valeur de l'item correspond
            for (let index = 0; index < all_filters.length; index++) {
              const field_name = all_filters[index].name;
              const filter_value = newFiltersValues[field_name];
              const item_value = item[field_name]
                ? all_filters[index].key && item[field_name][all_filters[index].key]
                  ? item[field_name][all_filters[index].key]
                  : (all_filters[index].type == "select" || all_filters[index].type == "chosen") &&
                    item[field_name] &&
                    item[field_name].id
                  ? item[field_name].id
                  : item[field_name]
                : null;

              // Si un seul filtre ne match pas, l'item n'est pas retenu du tout
              if (filter_value) {
                // Si une fonction de filtrage est définie dans la config
                if (typeof all_filters[index].filter == "function") {
                  if (all_filters[index].filter(this, filter_value, item_value, item) !== true) {
                    return false;
                  }
                }
                // Cas du filtrage sur une plage de date
                else if (all_filters[index].type == "date") {
                  if (filter_value.start) {
                    const start_date = this.$moment(filter_value.start);
                    if (!item_value || this.$moment(item_value).isBefore(start_date, "day")) {
                      return false;
                    }
                  }
                  if (filter_value.end) {
                    const end_date = this.$moment(filter_value.end);
                    if (!item_value || this.$moment(item_value).isAfter(end_date, "day")) {
                      return false;
                    }
                  }
                } else if (item_value != filter_value) {
                  return false;
                }
              }
            }
          }
          return true;
        }),
        this.config.fields.filter((field) => field.inList == true),
        true
      );
      this.totalRows = this.filtred_items.length;
    },
    /**
     * Callback appelé lorsqu'une ou des lignes sont sélectionnées
     * Prépare les données pour les exports CSV et PDF selon les lignes sélectionnées
     * @param   {array} rows  Tableau des lignes sélectionnées
     */
    rowSelected(rows) {
      // Dans le cas ou on sélectionne toutes les lignes on coche la checkbox "Sélectionner tout"
      // inversement, si on déselectionne une ligne, on décoche la checkbox "Sélectionner tout"
      this.allSelected =
        this.items.length < this.perPage
          ? rows.length == this.items.length
          : rows.length == this.perPage;

      this.selectedRowsCount = rows.length;

      // QR-005 : expose la sélection aux actions groupées (slot bulk-actions).
      this.selectedRows = rows;

      var formattedRows = [];
      rows.forEach((row) => {
        formattedRows.push({
          ...row,
          ...this.$root.formatData(
            row,
            this.config.fields.filter(
              (field) => field.inCsvExport == true && (field.inList != true || field.type == "date")
            )
          ),
        });
      });

      this.exportCsvRows = formattedRows.map((row) => {
        let output = {};
        this.config.fields
          .filter((field) => field.inCsvExport == true)
          .forEach((field) => {
            output[field.name] =
              field.type == "yesno"
                ? row[field.name] == true
                  ? "Oui"
                  : "Non"
                : row[field.name] || null;
          });
        return output;
      });
    },
    /**
     * Sélectionne un filtre par onglet
     * La valeur de l'onget est ajoutée au filtres étendus afin de filtrer la liste courante
     * @param {string}  value valeur de l'onglet
     */
    setTab(e, value) {
      this.$refs.tabs.querySelector(".tab.active").classList.remove("active");
      e.target.classList.add("active");
      let new_extended_filters_model = { ...this.extended_filters_model };
      new_extended_filters_model[this.tab_filter.name] = value;
      this.extended_filters_model = new_extended_filters_model;
      this.$emit("setTab", value);
    },
    /**
     * Exporte en PDF une seule ligne (bouton sur la ligne)
     * Prépare les données pour les envoyer à la fonction globale exportPdf()
     * @param {integer} item  Item à exporter
     */
    exportPdfSingle(item) {
      this.$store
        .dispatch(this.config.storeNamespace + "/getItem", {
          id: item.id,
          wait: true,
        })
        .then(() => {
          item = this.$store.getters[this.config.storeNamespace + "/getItem"](item.id);

          let formattedItem = this.$root.formatData(
            item,
            this.config.fields.filter((field) => field.inPdfExport == true)
          );

          let exportPdfData = {
            title: this.config.pdf_export_title
              ? this.config.pdf_export_title(item, formattedItem, this)
              : item[this.config.titleField],
            link: this.config.pdf_export_link
              ? this.config.pdf_export_link(item, formattedItem, this)
              : null,
            infos: [],
          };

          if (this.config.pdf_export_logo) {
            exportPdfData.logo = this.config.pdf_export_logo;
          }

          if (this.config.pdf_export_extra_content_before) {
            exportPdfData.extra_content_before = this.config.pdf_export_extra_content_before(
              item,
              formattedItem,
              this
            );
          }

          if (this.config.pdf_export_custom_main_content) {
            exportPdfData.custom_main_content = this.config.pdf_export_custom_main_content(
              item,
              formattedItem,
              this
            );
          } else {
            this.config.fields
              .filter((field) => field.inPdfExport == true)
              .forEach((field) => {
                exportPdfData.infos.push([
                  field.label + " :",
                  field.type == "yesno"
                    ? formattedItem[field.name] == true
                      ? "Oui"
                      : "Non"
                    : formattedItem[field.name] || null,
                ]);
              });
          }

          let lists = this.config.fields.filter((field) => field.type == "list");
          exportPdfData.lists = [];
          if (lists && lists.length) {
            lists.forEach((list) => {
              let currentList = {
                label: list.label,
                infos: [
                  list.fields.map((field) => list.config.fields.find((f) => f.name == field).label),
                ],
              };

              if (item[list.name]) {
                this.$root
                  .formatDatas(
                    item[list.name],
                    list.config.fields.filter((field) => field.inPdfExport == true)
                  )
                  .forEach((item) => {
                    let infosItem = [];
                    list.fields.forEach((field) => {
                      infosItem.push(item[field] || null);
                    });
                    currentList.infos.push(infosItem);
                  });
              }

              exportPdfData.lists.push(currentList);
            });
          }

          if (this.config.pdf_export_extra_lists) {
            exportPdfData.lists.push(
              ...this.config.pdf_export_extra_lists(item, formattedItem, this)
            );
          }

          if (this.config.pdf_export_extra_content_after) {
            exportPdfData.extra_content_after = this.config.pdf_export_extra_content_after(
              item,
              formattedItem,
              this
            );
          }

          this.$root.exportPdf(exportPdfData);
        });
    },
    openFormModal(id) {
      this.id_to_edit = id;
      // On reporte l'édition dans l'URL (?edit=<id>) pour rouvrir la modale au rafraîchissement
      const query = { ...this.$route.query };
      if (id) {
        query.edit = String(id);
      } else {
        delete query.edit;
      }
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query }).catch(() => {});
      }
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    onModalHidden(bvEvent, modalId) {
      if (modalId === "admin_modal_form" && this.$route.query.edit) {
        const query = { ...this.$route.query };
        delete query.edit;
        this.$router.replace({ query }).catch(() => {});
      }
    },
    submitCreateSuccess(response) {
      this.$emit("submit:create:success", response);
    },
    submitUpdateSuccess(response) {
      this.$emit("submit:update:success", response);
    },
    submitCreateError(error) {
      this.$emit("submit:create:error", error);
    },
    submitUpdateError(error) {
      this.$emit("submit:update:error", error);
    },
    orderUp(id) {
      var itemIndex = this.filtred_items.findIndex((item) => item.id == id);
      var itemPosition = this.filtred_items[itemIndex].position;

      if (itemPosition == 1) {
        return false;
      }

      var previousItemIndex = this.filtred_items.findIndex(
        (item) => item.position == itemPosition - 1
      );
      this.filtred_items[itemIndex].position = itemPosition - 1;
      this.filtred_items[previousItemIndex].position = itemPosition;

      this.saveOrder();
    },
    orderDown(id) {
      var itemIndex = this.filtred_items.findIndex((item) => item.id == id);
      var itemPosition = this.filtred_items[itemIndex].position;
      var maxPosition = Math.max(...this.filtred_items.map((item) => item.position));

      if (itemPosition == maxPosition) {
        return false;
      }

      var nextItemIndex = this.filtred_items.findIndex((item) => item.position == itemPosition + 1);
      this.filtred_items[itemIndex].position = itemPosition + 1;
      this.filtred_items[nextItemIndex].position = itemPosition;

      this.saveOrder();
    },
    saveOrder() {
      var self = this;
      clearTimeout(this.updateOrderTimer);
      this.updateOrderTimer = setTimeout(function () {
        self.filtred_items.forEach((item) => {
          self.$store.dispatch(self.config.storeNamespace + "/saveItem", item);
        });
      }, 2000);
    },
  },
};

function resolve(obj, path) {
  path = path.split(".");
  var current = obj;
  while (path.length) {
    if (typeof current !== "object") return undefined;
    current = current[path.shift()];
  }
  return current;
}
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.top-buttons {
  margin-top: -85px;
  min-height: 85px;
}

.tabs {
  background-color: $bg-1;
  width: 100%;
  border-radius: 0;
  overflow: hidden;

  .tab {
    padding: 15px 20px;
    text-align: center;
    text-transform: uppercase;
    @extend .clanprobold;
    color: $primary-darker;
    font-size: 13px;
    opacity: 0.5;
    cursor: pointer;

    &.active {
      color: $primary;
      opacity: 1;
      background-color: #fff;
      border-radius: 0;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
  }
}

.filters {
  border: solid 1px $border-10p;
  padding: 6px 20px;
  border-radius: 0;

  .search-bar {
    color: $text-50p;

    input {
      border: none;
      @extend .clanprobook;
    }

    button.btn {
      color: inherit;
      background: none;
      border: none;
    }
  }

  .filters-toggle a {
    @extend .clanprobold;
    color: $text-50p;
    text-transform: uppercase;
  }

  .filter-col {
    flex-basis: 25%;
  }
}

.select-all {
  color: $text-30p;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  @extend .clanprobold;
  line-height: 24px;
}

.total {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/Global/AdminTable.vue